import { render } from "./CustomAddressField.vue?vue&type=template&id=0c32be18&scoped=true"
import script from "./CustomAddressField.vue?vue&type=script&lang=js"
export * from "./CustomAddressField.vue?vue&type=script&lang=js"

import "./CustomAddressField.vue?vue&type=style&index=0&id=0c32be18&lang=stylus&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c32be18"]])

export default __exports__